export class ImagePreview {
    private overlay: HTMLElement;
    private videoContainer: HTMLElement | null;
    private video: HTMLVideoElement | null;

    constructor(overlay: HTMLElement) {
        if (!overlay.hasAttribute('data-image-overlay')) {
            throw new Error("Element does not have data-image-overlay attribute");
        }
        this.overlay = overlay;
        this.videoContainer = null;
        this.video = null;
        this.init();
    }

    private init(): void {
        this.findVideoElements();
        this.addPlayVideo();
    }

    private findVideoElements(): void {
        const overlayId = this.overlay.getAttribute('data-image-overlay');
        if (overlayId) {
            this.videoContainer = document.querySelector<HTMLElement>(`[data-image-overlay-target-video="${overlayId}"]`);
            if (this.videoContainer) {
                this.video = this.videoContainer.querySelector<HTMLVideoElement>('video');
            }
        }

    }

    private addPlayVideo(): void {
        this.overlay.addEventListener('click', () => {
            if (this.video) {
                this.overlay.style.display = 'none';
                this.video.play().catch(error => console.error('Error playing video:', error));
            }
        });
    }
}

document.addEventListener('turbo:load', () => {
    document.querySelectorAll<HTMLElement>('[data-image-overlay]').forEach(el => {
        new ImagePreview(el);
    });
});

document.addEventListener('turbo:frame-load', () => {
    document.querySelectorAll<HTMLElement>('[data-image-overlay]').forEach(el => {
        new ImagePreview(el);
    });
});

document.addEventListener('turbo:render', () => {
    document.querySelectorAll<HTMLElement>('[data-image-overlay]').forEach(el => {
        new ImagePreview(el);
    });
});


